import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Issue from '@/components/Issue'
import Tetatet from '@/components/Tetatet'
import Colophon from '@/components/Colophon'
import IssueInner from '@/components/IssueInner'
import store from '../store'
import axios from 'axios'
import _ from 'underscore'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: (to, from, next) => {
        store.dispatch('LOAD_DATASET').then(() => {
          next()
        })
      }
    }, {
      path: '/tetatet',
      name: 'Tetatet',
      component: Tetatet,
      beforeEnter: (to, from, next) => {
        store.dispatch('LOAD_DATASET').then(() => {
          next()
        })
      }
    }, {
      path: '/colophon',
      name: 'Colophon',
      component: Colophon
    }, {
      path: '/:index',
      name: 'Issue',
      component: Issue,
      props: true,
      beforeEnter: (to, from, next) => {
        store.dispatch('LOAD_DATASET').then(() => {
          next()
        })
      }
    }, {
      path: '/:index/:id',
      name: 'IssueInner',
      component: IssueInner,
      props: true,
      beforeEnter: (to, from, next) => {
        store.dispatch('LOAD_DATASET').then(() => {
          next()
        })
      }
    },
    { path: '*', redirect: '/' }
  ],
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js